module.exports = __webpack_public_path__ + "static/media/PLANCHAL_MENU-normal.73fad34a.png";